class MobileSortModal {
  constructor() {
    this.modal = document.getElementById('mobile-sort-modal');
    if (!this.modal) return;

    this.trigger = document.querySelector('.mobile-sort-trigger');
    this.backdrop = this.modal.querySelector('.mobile-sort-modal__backdrop');
    this.closeBtn = this.modal.querySelector('.mobile-sort-modal__close');
    this.radioInputs = this.modal.querySelectorAll('.mobile-sort-modal__radio');
    
    this.init();
  }

  init() {
    // Open modal
    if (this.trigger) {
      this.trigger.addEventListener('click', () => this.open());
    }

    // Close modal
    if (this.backdrop) {
      this.backdrop.addEventListener('click', () => this.close());
    }
    
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', () => this.close());
    }

    // Handle sort selection
    this.radioInputs.forEach(radio => {
      radio.addEventListener('change', (e) => this.handleSort(e));
    });

    // Close on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.modal.classList.contains('active')) {
        this.close();
      }
    });
  }

  open() {
    this.modal.classList.add('active');
    this.trigger.classList.add('active');
    document.body.classList.add('mobile-sort-modal-open');
  }

  close() {
    this.modal.classList.remove('active');
    this.trigger.classList.remove('active');
    document.body.classList.remove('mobile-sort-modal-open');
  }

  handleSort(e) {
    const sortValue = e.target.value;
    
    // Update active state on labels
    const labels = this.modal.querySelectorAll('.mobile-sort-modal__label');
    labels.forEach(label => label.classList.remove('active'));
    e.target.closest('.mobile-sort-modal__label').classList.add('active');

    // Update check icons
    const checks = this.modal.querySelectorAll('.mobile-sort-modal__check');
    checks.forEach(check => check.remove());
    
    const checkIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    checkIcon.setAttribute('class', 'mobile-sort-modal__check');
    checkIcon.setAttribute('width', '20');
    checkIcon.setAttribute('height', '20');
    checkIcon.setAttribute('viewBox', '0 0 20 20');
    checkIcon.setAttribute('fill', 'none');
    checkIcon.innerHTML = '<path d="M16.6667 5L7.50004 14.1667L3.33337 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>';
    e.target.closest('.mobile-sort-modal__label').appendChild(checkIcon);

    // Apply sort - update URL and reload
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set('sort_by', sortValue);
    
    // Close modal after a short delay
    setTimeout(() => {
      window.location.search = searchParams.toString();
    }, 300);
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new MobileSortModal();
  });
} else {
  new MobileSortModal();
}

